import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/GetInTouch.css';
import LetsTalkButton from './LetsTalkButton';

const GetInTouchSection = () => {

  const handleNavClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <section className="get-in-touch-section">
      <div className="get-in-touch-container">
        <h1 className="get-in-touch-title">Get in touch with Inypeople</h1>

        <p className="get-in-touch-subtitle">
          Let's work together to create something truly remarkable and your expectations.
        </p>

        <div className="get-in-touch-btn-center">
          <LetsTalkButton />
        </div>
      </div>
    </section>
  );
};

export default GetInTouchSection;
